<template>
  <div>
    <v-dialog v-model="dialogShow" persistent width="40%" height="40%">
      <v-card>
        <v-card-title style="box-shadow: 0 2px 7px 0 #A6A6A63F;font-size: 20px;" class="alibabaPuHuiTiFontFamily">
          文件上传
          <v-spacer></v-spacer>
          <p @click="hideDialog" style="float:right;font-size:14px;color:#A6A6A6;cursor:pointer;"
             class="iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <div style="position:relative;height:600px;border-top:1px solid transparent;">
            <!--第一步 上传图片-->
            <div style="width:400px;margin:180px auto 0 auto;">
              <div style="display:flex;flex-direction: column;align-items: center;">
                <div style="position:relative;width:200px;height:150px;margin:0 auto;" @drop="reportDrop">
                  <div style="width:100%;height:100%;border:1px dashed #a6a6a6;border-radius:2px;">
                    <p style="font-size:30px;text-align:center;line-height:150px;color:#1976D2;" class="iconfontFamily">
                      &#xe60b;</p>
                  </div>
                  <input ref="uploadImageInput" @change="uploadFile" type="file"
                         style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;">
                </div>
                <p style="font-size:16px;color:#000000;" class="mt-2">拖入或点击上传文件</p>
                <p style="font-size:14px;color:#a6a6a6;" class="mt-8">支持KML、KMZ格式文件上传</p>
                <p style="font-size:14px;color:#a6a6a6;" class="mt-2">
                  支持shp数据上传(需上传包含.shp、.shx、.dbf和.prj的zip)</p>
                <p style="font-size:14px;color:#a6a6a6;" class="mt-2">支持csv数据转换</p>
                <p @click="downloadSample" style="font-size:16px;color:rgba(42,130,228,1);cursor: pointer"
                   class="mt-8 iconfontFamily">&#xe67e; 样例数据下载</p>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <loading-dialog :text="loadingText" :loading-dialog-show="decodeFileCardShow"
                    @closeLoadingDialog="closeLoadingDialog"></loading-dialog>
    <v-dialog v-model="generateDialogShow" persistent width="40%" height="40%">
      <v-card>
        <v-card-title style="box-shadow: 0 2px 7px 0 #A6A6A63F;font-size: 20px;" class="alibabaPuHuiTiFontFamily">
          <p style="color: black">文件生成</p>
          <v-spacer></v-spacer>
          <p @click="closeGenerateDialog" style="float:right;font-size:14px;color:#A6A6A6;cursor:pointer;"
             class="iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <div class="px-7 py-3" style="width: 100%;overflow-x: hidden;overflow-y: scroll;scrollbar-width: none;" :style="{'height': dynamicHeight + 'px'}">
            <div style="width: 100%;height: 150px;background: rgba(42,130,228,0.1);padding: 20px">
              <div style="height: 53px;display: flex;" class="pt-2">
                <div v-if="!isEditFileName" style="display: flex">
                  <p class="alibabaPuHuiTiFontFamily" style="font-size: 18px;font-weight: 700;color: black">
                    {{ fileName }}</p>
                  <p @click="editFileName" class="iconfontFamily"
                     style="font-size: 16px;color: black;margin-left: 14px;cursor: pointer">&#xe66c;</p>
                </div>
                <div style="margin-top: -15px" v-if="isEditFileName">
                  <v-text-field style="font-weight: 700;font-size: 18px;" v-model="tempFileName"
                                class="alibabaPuHuiTiFontFamily">
                    <template v-slot:append>
                      <span @click="cancelEditFileName"
                            style="color: rgba(128,128,128,1);cursor: pointer;font-weight: 400;font-size: 14px"
                      >取消</span>
                      <span @click="saveFileName"
                            style="margin-left: 12px;color: rgba(42,130,228,1);cursor: pointer;font-weight: 400;font-size: 14px"
                      >保存</span>
                    </template>
                  </v-text-field>
                </div>
              </div>
              <div style="width: 508px">
                <p style="color: rgba(0,0,0,1)" class="alibabaPuHuiTiFontFamily">
                  文件解析完毕，可通过下方选择数据进行导入。</p>
                <p style="color: rgba(166,166,166,1)" class="alibabaPuHuiTiFontFamily">
                  注：CG文件默认坐标系为GCJ02（即火星坐标系），不同格式文件导入的过程中可能会有一定的坐标偏移。</p>
              </div>
            </div>
            <div class="mt-4"
                 :style="{'height' : showElTree ? '221px' : '40px','border' : showElTree ? '1px solid rgba(42,130,228,1)' : '1px solid rgba(229,229,229,1)'}"
                 style="width: 100%;height: 221px;border-radius: 2px;">
              <div class="px-2 py-2" style="width: 100%;height: 100%;overflow-y: scroll;overflow-x: hidden;scrollbar-width: none;">
                <!--树形结构-->
                <div
                    style="border-bottom: 1px solid rgba(229,229,229,1);height: 35px;line-height: 27px;display: flex;justify-content: space-between;padding-right: 10px">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="selectAll" @change="handleCheckAllChange">
                    <div style="color: rgba(128,128,128,1)">已解析对象 {{ selectNodeCount }}/{{ allNodeCount }}</div>
                  </el-checkbox>
                  <div @click="elTreeVisibleControl" style="color: rgba(196,196,196,1);cursor: pointer"
                       class="iconfontFamily" v-html="showElTree ? '&#xe644;' : '&#xe645;'"></div>
                </div>
                <el-tree
                    v-show="showElTree"
                    :indent="20"
                    :data="fileInfo"
                    node-key="id"
                    default-expand-all
                    ref="tree"
                    @check="handleCheck"
                    show-checkbox
                >
                  <template v-slot="{node, data}">
                    <div
                        style="display: flex;color: black;height: 35px;line-height: 35px;width: 100%;position: relative;font-weight: 500">
                      <span :style="{'color' : data.type === 'folder' ? 'rgba(42,130,228,1)' : 'rgba(196,196,196,1)'}"
                            style="margin-right: 6px" class="iconfontFamily" v-html="iconMap[data.type][0]"></span>
                      <span>{{ data.name }}</span>
                      <div style="position: absolute;right: 20px;text-align: center;width: 75px">
                        <p style="">{{ iconMap[data.type][1] }}</p>
                      </div>
                    </div>
                  </template>
                </el-tree>
              </div>
            </div>
            <div style="border-bottom: 1px solid rgba(229,229,229,1)" class="mt-4"></div>
            <div style="height: 80px">
              <p style="margin-top: 10px;font-size: 15px">文件生成为</p>
              <div style="display: flex;height: 68px;width:100%;line-height: 80px;color: black">
                <v-radio-group v-model="fileType" row>
                  <v-radio :value="0">
                    <template v-slot:label>
                      <span style="color: black;margin-top: 2px">个人文件</span>
                    </template>
                  </v-radio>
                  <v-radio style="margin-left: 100px" :value="1">
                    <template v-slot:label>
                      <span style="color: black;margin-top: 2px">团队文件</span><span class="new-icon">NEW</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </div>
            <div v-show="fileType === 1">
              <div style="">
                <p style="margin-top: 10px;font-size: 15px">团队文件配置</p>
                <div style="height: 68px;width:100%;line-height: 80px;color: black">
                  <v-radio-group v-model="teamReadOnly">
                    <v-radio :value="0">
                      <template v-slot:label>
                        <div style="display: flex"
                             :style="{'color' : teamReadOnly === 0 ? 'black' : 'rgba(128,128,128,1)'}">
                          <span style="margin-top: 2px">团队文件中数据可新增</span>
                          <p style="margin-left: 60px">可新增数据，同时可编辑、删除本人创建的数据</p>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio style="margin-top: 10px" :value="1">
                      <template v-slot:label>
                        <div style="display: flex"
                             :style="{'color' : teamReadOnly === 1 ? 'black' : 'rgba(128,128,128,1)'}">
                          <span style="margin-top: 2px">团队文件只读</span>
                          <p style="margin-left: 123px">团队文件中所有的数据都不能由协作者进行编辑</p>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
              </div>
              <div style="border-bottom: 1px solid rgba(229,229,229,1)" class="mt-4"></div>
              <el-checkbox v-model="teamExport" style="margin-left: 7px;">
                <div style="color: black;font-size: 16px;line-height: 50px;" class="ml-1">
                  允许团队协作者复制、导出团队文件
                </div>
              </el-checkbox>
              <div style="border-bottom: 1px solid rgba(229,229,229,1)"></div>
              <el-checkbox v-model="teamSave" style="margin-left: 7px;">
                <div style="color: black;font-size: 16px;line-height: 50px;" class="ml-1">
                  允许团队文件协作者下载、删除附件
                </div>
              </el-checkbox>
              <div style="border-bottom: 1px solid rgba(229,229,229,1)"></div>
              <el-checkbox v-model="teamInvite" style="margin-left: 7px;">
                <div style="color: black;font-size: 16px;line-height: 50px;" class="ml-1">
                  允许团队文件协作者邀请其他协作者
                </div>
              </el-checkbox>
            </div>
          </div>
          <div style="border-bottom: 1px solid rgba(229,229,229,1)"></div>
          <div style="height: 64px; width: 100%;position: relative">
            <div @click="fileUploadConfirm" class="confirm-btn">
              <p style="text-align: center;color: white">确定</p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import LoadingDialog from "@/views/globe/dialog/file_manage/LoadingDialog.vue";
import * as turf from "@turf/turf";

export default {
  name: "UploadFileDialog",
  components: {LoadingDialog},
  props: ["dialogShow"],
  data() {
    return {
      loadingText: '文件解析中......',
      decodeFileCardShow: false,
      generateDialogShow: false,
      fileType: 0, // 个人0 团队1
      fileName: '',
      isEditFileName: false,
      originalFileName: '',
      fileInfo: '',
      showElTree: false,
      tempFileName: '',
      iconMap: {
        'folder': ['&#xe64d;', '-'],
        'point': ['&#xe62d;', '点位标记'],
        'lineString': ['&#xe669;', '直线标记'],
        'polygon': ['&#xe668;', '多边形标记'],
        'circle': ['&#xe670;', '圆形标记'],
        'rectangle': ['&#xe66e;', '矩形标记'],
        'roadString': ['&#xe661;', '路线规划']
      },
      isIndeterminate: false,
      selectAll: true,
      selectNodeCount: 0,
      allNodeCount: 0,
      fileNodeCount: 0,
      teamReadOnly: 0,// 0为可新增 1为只读
      teamExport: true, //允许导出为1
      teamSave: true, //允许保存为1
      teamInvite: true, //允许邀请为1
      dynamicHeight: 500,
      filteredNodes: '',
      fileDecodeStatus: '',
      maxFileNameCharacter: 30,
      currUploadFile: '',
      isDrop: false,
    }
  },
  methods: {
    judgeUploadType(fileName) {
      let strs = fileName.split('.')
      let type = strs[strs.length - 1]
      let supportType = ['cg', 'kml', 'kmz', 'zip', 'csv']
      return supportType.indexOf(type) > -1
    },
    reportDrop(event) {
      event.preventDefault()
      this.isDrop = true
      this.currUploadFile = event.dataTransfer.files[0];
      this.uploadFile()
    },
    //上传图片
    async uploadFile() {
      // 类型校验
      let file = ''
      if (this.isDrop) {
        file = this.currUploadFile
      } else {
        file = this.$refs.uploadImageInput.files[0]
      }
      this.isDrop = false
      if (!this.judgeUploadType(file.name)) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "文件必须为以下格式：cg、kml、kmz、csv、zip"
        this.$store.state.snackbarType = 'error'
        this.$refs.uploadImageInput.value = '';
      } else if (file.size > 1024 * 1024 * 10) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "文件大于10M，无法上传"
        this.$store.state.snackbarType = 'error'
        this.$refs.uploadImageInput.value = '';
      } else {
        //合法
        let paramData = new FormData();
        this.decodeFileCardShow = true
        paramData.append('multipartFile', file);
        await this.$axios.post('/authorApi/z-geo-file/fileImport', paramData)
            .then((resultData) => {
              resultData = resultData.data;
              if (resultData.status === 200) {
                this.fileDecodeStatus = 'success'
                this.fileName = resultData.data['fileName']
                this.fileInfo = resultData.data['content']
                this.filteredNodes = this.fileInfo // 初始是全部选中的状态 在handle里面改变选中
              } else {
                this.fileDecodeStatus = 'fail'
                this.$store.state.snackbarShow = true
                this.$store.state.snackbarText = "文件解析失败"
                this.$store.state.snackbarType = 'error'
                this.$refs.uploadImageInput.value = '';
                console.log(resultData.status + resultData.message);
              }
            })
            .catch((err) => {
              console.log(err)
            })
        this.hideDialog()
        this.decodeFileCardShow = false
        // 解析成功才展示
        if (this.fileDecodeStatus === 'success') {
          this.generateDialogShow = true
          setTimeout(() => {
            this.$refs.tree.setCheckedNodes(this.fileInfo)
            for (let i = 0; i < this.fileInfo.length; i++) {
              this.allNodeCount += this.getAllNodesCount(this.fileInfo[i])
            }
            this.selectNodeCount = this.allNodeCount
            this.fileNodeCount = this.allNodeCount
          }, 100)
        }
      }
    },
    elTreeVisibleControl() {
      this.showElTree = !this.showElTree;
      if (this.showElTree) {
        this.dynamicHeight += 200
      } else {
        this.dynamicHeight -= 200
      }
    },
    downloadSample() {
      const downloadLink = document.createElement('a');
      downloadLink.href = 'https://market.obs.cn-north-4.myhuaweicloud.com/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%C2%B7%E5%85%B1%E7%94%9F%E5%9C%B0%E7%90%83%E6%96%87%E4%BB%B6%E7%AE%A1%E7%90%86%E6%A0%B7%E4%BE%8B%E6%95%B0%E6%8D%AE.zip';
      document.body.appendChild(downloadLink);
      downloadLink.click(); // 模拟用户点击下载链接
      document.body.removeChild(downloadLink);
    },
    closeGenerateDialog() {
      this.generateDialogShow = false
      this.$emit('hideWholeDialog')
    },
    handleCheckAllChange() {
      if ((this.selectAll && !this.isIndeterminate) || this.isIndeterminate) {
        // 全选
        this.selectAll = true
        this.isIndeterminate = false
        this.$refs.tree.setCheckedNodes(this.fileInfo)
        this.filteredNodes = this.fileInfo
        this.selectNodeCount = this.fileNodeCount
      } else {
        // 全不选
        this.selectAll = false
        this.isIndeterminate = false
        this.filteredNodes = []
        this.$refs.tree.setCheckedNodes([])
        this.selectNodeCount = 0
      }
    },
    handleCheck(node, status) {
      let checkedKeys = []
      let halfAndFullCheckedKeys = []
      for (let i = 0; i < status['checkedKeys'].length; i++) {
        checkedKeys.push(status['checkedKeys'][i])
        halfAndFullCheckedKeys.push(status['checkedKeys'][i])
      }
      for (let i = 0; i < status['halfCheckedKeys'].length; i++) {
        halfAndFullCheckedKeys.push(status['halfCheckedKeys'][i])
      }
      let cnt = 0
      let nodes = []
      for (let i = 0; i < this.fileInfo.length; i++) {
        cnt += this.getSelectNodeCount(this.fileInfo[i], checkedKeys)
        let currNode = this.getFilteredNodes(this.fileInfo[i], halfAndFullCheckedKeys)
        if (currNode !== '') {
          nodes.push(currNode)
        }
      }
      this.selectNodeCount = cnt
      this.filteredNodes = nodes
      if (this.selectNodeCount === this.fileNodeCount) {
        this.isIndeterminate = false
        this.selectAll = true
      }
      if (this.selectNodeCount !== this.fileNodeCount) {
        this.isIndeterminate = true
        this.selectAll = false
      }
      if (this.selectNodeCount === 0) {
        this.isIndeterminate = false
        this.selectAll = false
      }
    },
    getFilteredNodes(node, halfAndFullCheckedKeys) {
      if (halfAndFullCheckedKeys.indexOf(node['id']) < 0) {
        return ''
      }
      let curr = Object.assign({}, node)
      let children = []
      for (let i = 0; i < node['children'].length; i++) {
        let childNode = this.getFilteredNodes(node['children'][i], halfAndFullCheckedKeys)
        if (childNode !== '') {
          children.push(childNode)
        }
      }
      curr['children'] = children
      return curr
    },
    getSelectNodeCount(node, checkedNodes) {
      if (node['type'] !== 'folder' && checkedNodes.indexOf(node['id']) > -1) {
        return 1
      }
      let cnt = 0
      for (let i = 0; i < node['children'].length; i++) {
        cnt += this.getSelectNodeCount(node['children'][i], checkedNodes)
      }
      return cnt
    },
    getAllNodesCount(node) {
      if (node['type'] !== 'folder') {
        return 1
      }
      let cnt = 0
      for (let i = 0; i < node['children'].length; i++) {
        cnt += this.getAllNodesCount(node['children'][i])
      }
      return cnt
    },
    editFileName() {
      this.originalFileName = this.fileName
      this.tempFileName = this.fileName
      this.isEditFileName = !this.isEditFileName
    },
    cancelEditFileName() {
      this.isEditFileName = !this.isEditFileName
      this.fileName = this.originalFileName
    },
    judgeFileName() {
      if (this.tempFileName.length > this.maxFileNameCharacter) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "文件名过长(超过30字)"
        this.$store.state.snackbarType = 'error'
        return false
      }
      return true
    },
    saveFileName() {
      if (this.judgeFileName()) {
        this.fileName = this.tempFileName
        this.isEditFileName = !this.isEditFileName
      }
    },
    closeLoadingDialog() {
      this.hideDialog()
      this.decodeFileCardShow = false
      this.$emit('hideWholeDialog')
    },
    //隐藏弹窗
    hideDialog() {
      this.$emit("hideUploadDialog")
    },
    //为选择导入的数据补充周长和面积
    chooseFolderGetLengthAndArea(treeList) {
      //深度遍历 turf计算长度 面积
      //分类型 lineString  polygon
      for (let i = 0; i < treeList.length; i++) {
        if (treeList[i].type === "folder" && treeList[i].children && treeList[i].children.length > 0) {
          //是目录 同时有孩子
          this.chooseFolderGetLengthAndArea(treeList[i].children)
        } else if (treeList[i].type !== "folder") {
          //是标记
          if (treeList[i].type === "lineString") {
            if (treeList[i].geoJson.geo.geometry.type === "MultiLineString") {
              let len = 0;
              for (let j = 0; j < treeList[i].geoJson.geo.geometry.coordinates.length; j++) {
                len = len + turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates[j]), {units: 'kilometers'})
              }
              treeList[i].geoJson.geo.properties.len = len * 1000
            } else if (treeList[i].geoJson.geo.geometry.type === "LineString") {
              treeList[i].geoJson.geo.properties.len = turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates), {units: 'kilometers'}) * 1000
            }
          } else if (treeList[i].type === "polygon") {
            if (treeList[i].geoJson.geo.geometry.type === "MultiPolygon") {
              let area = 0;
              let len = 0;
              for (let j = 0; j < treeList[i].geoJson.geo.geometry.coordinates.length; j++) {
                len = len + turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates[j][0]), {units: 'kilometers'}) * 1000
                area = area + turf.area(turf.polygon(treeList[i].geoJson.geo.geometry.coordinates[j]))
              }
              treeList[i].geoJson.geo.properties.len = len
              treeList[i].geoJson.geo.properties.area = area
            } else if (treeList[i].geoJson.geo.geometry.type === "Polygon") {
              treeList[i].geoJson.geo.properties.len = turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates[0]), {units: 'kilometers'}) * 1000
              treeList[i].geoJson.geo.properties.area = turf.area(turf.polygon(treeList[i].geoJson.geo.geometry.coordinates))
            }
          }
        } else {
          //是目录，但是没有孩子
        }
      }
    },
    fileUploadConfirm() {
      if (!this.judgeFileName()) {
        return
      }
      this.chooseFolderGetLengthAndArea(this.filteredNodes)
      this.$axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        url: '/authorApi/z-geo-file/fileConfirm',
        data: {
          fileName: this.fileName,
          authority: this.fileType,
          teamReadonly: this.teamReadOnly,
          teamExport: this.teamExport ? '1' : '0',
          teamSave: this.teamSave ? '1' : '0',
          teamInvite: this.teamInvite ? '1' : '0',
          content: this.filteredNodes,
        }
      }).then((resp) => {
        resp = resp['data']
        if (resp['status'] === 200) {
          this.generateDialogShow = false
          this.$emit("searchInputEnter")
          this.$emit('hideWholeDialog')
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "文件上传成功"
          this.$store.state.snackbarType = 'success'
        } else if (resp['status'] === 308) {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "文件名不可重复"
          this.$store.state.snackbarType = 'error'
        }
      })
    },
  },
  mounted() {
    this.fileType = 0
    this.isEditFileName = false
    this.showElTree = false
    this.isIndeterminate = false
    this.selectAll = true
    this.teamReadOnly = 0
    this.teamExport = true
    this.teamSave = true
    this.teamInvite = true
    this.dynamicHeight = 500
    this.allNodeCount = 0
    this.selectNodeCount = 0
  }
}
</script>
<style scoped>
.new-icon {
  background: red;
  width: 28px;
  height: 12px;
  font-size: 8px;
  color: white;
  line-height: 12px;
  text-align: center;
  border-radius: 14px 6px 14px 0;
  margin-left: 3px;
  margin-top: -2px
}

.confirm-btn {
  position: absolute;
  right: 30px;
  bottom: 14px;
  height: 35px;
  line-height: 35px;
  width: 100px;
  background: rgba(42, 130, 228, 1);
  cursor: pointer;
}

:deep(.el-tree-node__content) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
  border-top: 1px solid transparent;
}

:deep(.el-tree-node__content):hover {
  background-color: rgba(42, 130, 228, 0.1) !important;
  border-top: none !important;
  border-bottom: none !important;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: rgba(41, 122, 255, 1);
  border-color: rgba(41, 122, 255, 1);
}

:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background-color: rgba(41, 122, 255, 1);
  border-color: rgba(41, 122, 255, 1);
}

::-webkit-scrollbar {
  display: none;
}
</style>